import React, { useState, useRef, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Container, Modal } from 'react-bootstrap'
import { Row, Col } from 'antd'
import Slider from 'react-slick'
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleIcon,
  CollapsibleTrigger,
} from '@wartek-id/collapsible'
import { useInView } from 'react-intersection-observer'

const Penyedia = ({ clickVideo, clickHelpCenter, clickPartner }) => {
  const imageRef = useRef(null)
  const [isVideoOpen, setIsVideoOpen] = useState(false)

  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    centerMode: false,
    variableWidth: false,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  const [collapse, setCollapse] = useState([
    {
      id: 1,
      open: false,
      title: 'Bagaimana cara mendaftar sebagai Penyedia?',
      content:
        'Persyaratan dan cara mendaftar sebagai Penyedia dapat dilihat dengan mengunjungi situs masing-masing mitra dan pada informasi berikut <a href="http://bit.ly/siplah-daftar" target="_blank">bit.ly/siplah-daftar</a>',
    },
    {
      id: 2,
      open: false,
      title: 'Apakah semua Penyedia harus menjadi Pengusaha Kena Pajak (PKP)?',
      content:
        'Semua penyedia yang ingin bertransaksi di SIPLah secara otomatis dianggap menjadi PKP. Khusus untuk penyedia dengan omzet diatas 4,8 milyar per tahun, wajib mengajukan pengukuhan PKP pada Kantor Perwakilan Pajak terdekat.',
    },
    {
      id: 3,
      open: false,
      title: 'Apakah Penyedia wajib memiliki NPWP?',
      content:
        'Iya. Sesuai Pasal 3 Ayat (1) PMK 58/PMK.03/2022 poin a dan b: Penyedia wajib memiliki NPWP dan melaporkan usahanya ke DJP untuk dikukuhkan sebagai Pengusaha Kena Pajak (PKP).',
    },
    {
      id: 4,
      open: false,
      title: 'Apa saja pajak yang dikenakan dalam setiap transaksi di SIPLah?',
      content:
        'Setiap transaksi di SIPLah akan terkena pajak berikut, masing-masing dihitung dari total nilai transaksinya:<br/>1. PPN sebesar 11% dikenakan pada satuan pendidikan pengguna SIPLah<br/>2. PPh 22 sebesar 0,5% dikenakan pada penyedia barang dan jasa di SIPLah',
    },
    {
      id: 5,
      open: false,
      title: 'Apakah Penyedia sama dengan Mitra?',
      content:
        '<b>Tidak</b>. Penyedia berbeda dengan Mitra. Penyedia adalah penjual barang atau jasa kebutuhan satuan pendidikan. Sedangkan Mitra adalah pengelola pasar daring SIPLah.',
    },
    {
      id: 6,
      open: false,
      title: 'Jika saya sebagai Penyedia ingin bergabung dengan Mitra yang baru, apakah saya harus mengikuti proses dari awal kembali?',
      content:
        'Proses pendaftaran Penyedia pada Mitra baru tergantung pada kebijakan masing-masing Mitra. Namun, Penyedia dapat mempersiapkan dokumen yang diperlukan jika harus mengikuti proses dari awal kembali.',
    },
  ])

  const changeCollapse = (id) => {
    setCollapse(
      collapse.map((item) =>
        item.id === id ? { ...item, open: !item.open } : item,
      ),
    )
  }

  const handleClickVideo = () => {
    setIsVideoOpen(true)
    clickVideo()
  }

  const handleClickHelpCenter = () => {
    clickHelpCenter()
  }

  const handleClickPartner = (marketplace_name, button_name) => {
    clickPartner(marketplace_name, button_name)
  }

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0,
  })

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0,
  })

  const { ref: thirdContainer, inView: thirdInView } = useInView({
    threshold: 0,
  })

  const { ref: fourthContainer, inView: fourthInView } = useInView({
    threshold: 0,
  })

  const { ref: fifthContainer, inView: fifthInView } = useInView({
    threshold: 0,
  })

  const getImage = () => {
    if (firstInView) return './assets/cara-kerja/img-penyedia-daftar.png'
    if (secondInView) return './assets/cara-kerja/img-penyedia-input-produk.png'
    if (thirdInView)
      return './assets/cara-kerja/img-penyedia-menerima-pesanan.png'
    if (fourthInView) return './assets/cara-kerja/img-penyedia-mengirimkan.png'
    if (fifthInView)
      return './assets/cara-kerja/img-penyedia-menerima-pembayaran.png'
    return './assets/cara-kerja/img-penyedia-daftar.png'
  }

  const listMitra = [
    // {
    //   image: './assets/mitra/innolaku.png',
    //   width: '120px',
    //   height: '60px',
    //   name: 'PT Deka Sari Perkasa',
    //   link: 'https://siplah.innolaku.id/',
    //   phone: '021 - 82582000',
    //   link_panduan: 'https://siplah.innolaku.id/panduan',
    //   link_daftar: 'https://siplah.innolaku.id/seller/daftar',
    // },
    {
      image: './assets/mitra/eureka.png',
      width: '120px',
      height: '60px',
      name: 'PT Eureka Bookhouse',
      link: 'https://siplah.eurekabookhouse.co.id/',
      phone: '021 - 87796010',
      link_panduan: 'https://siplah.eurekabookhouse.co.id/satdik/site/tutorial',
      link_daftar: 'https://siplah.eurekabookhouse.co.id/penyedia/register',
    },
    {
      image: './assets/mitra/blibli.png',
      width: '120px',
      height: '60px',
      name: 'PT Global Digital Niaga',
      link: 'https://siplah.blibli.com/',
      phone: '0804 - 1871871',
      link_panduan: 'https://siplah.blibli.com/guide',
      link_daftar: 'https://siplah.blibli.com/register/merchant',
    },
    {
      image: './assets/mitra/intan.png',
      width: '120px',
      height: '60px',
      name: 'PT Intan Pariwara',
      link: 'https://siplah.intanonline.com/',
      phone: '0811 - 2573647',
      link_panduan:
        'https://siplah.intanonline.com/frontend/web/site/cara-belanja',
      link_daftar:
        'https://siplah.intanonline.com/frontend/web/register/account',
    },
    {
      image: './assets/mitra/ladang.png',
      width: '120px',
      height: '60px',
      name: 'PT Ladang Karya Husada',
      link: 'https://siplah.tokoladang.co.id/',
      phone: '0813 - 57337352',
      link_panduan: 'https://siplah.tokoladang.co.id/help/belanja',
      link_daftar: 'https://seller.siplah.tokoladang.co.id/register',
    },
    {
      image: './assets/mitra/masmedia.png',
      width: '120px',
      height: '60px',
      name: 'PT Masmedia Buana Pustaka',
      link: 'https://siplahmasmedia.co.id/',
      phone: '031 - 8665152',
      link_panduan: 'https://siplahmasmedia.co.id/home',
      link_daftar: 'https://siplahmasmedia.co.id/home',
    },
    {
      image: './assets/mitra/mitra edukasi.png',
      width: '120px',
      height: '60px',
      name: 'PT Mitra Edukasi Nusantara',
      link: 'https://siplahgramedia.id/',
      phone: '021 - 5483008 (ext 2634 - 2636)',
      link_panduan: 'https://siplahgramedia.id/dashboard/panduan',
      link_daftar: 'https://siplahgramedia.id/SellerRegister',
    },
    {
      image: './assets/mitra/telkom.png',
      width: '120px',
      height: '60px',
      name: 'PT Telekomunikasi Indonesia',
      link: 'https://siplahtelkom.com/',
      phone: 'Tersedia Fitur Chat di Website',
      link_panduan:
        'https://siplahtelkom.com/assets/doc/SIPlahTelkom-CARA-SEKOLAH-BERTRANSAKSI.pdf',
      link_daftar: 'https://siplahtelkom.com/auth/register',
    },
    {
      image: './assets/mitra/temprina.png',
      width: '120px',
      height: '60px',
      name: 'PT Temprina Media Grafika',
      link: 'https://siplah.temprina.co.id/',
      phone: '031 - 8982999',
      link_panduan: 'https://siplah.temprina.co.id/blog/Tutorial-Pembeli',
      link_daftar: 'https://siplah.temprina.co.id/register',
    },
    // {
    //   image: './assets/mitra/emaro.png',
    //   width: '120px',
    //   height: '60px',
    //   name: 'PT Emaro Online Indonesia',
    //   link: 'https://siplah.klikmro.com/',
    //   phone: '021 - 5829051',
    //   link_panduan: 'https://siplah.klikmro.com/panduan-berbelanja',
    //   link_daftar: 'https://penyedia.klikmro.com/register',
    // },
    // {
    //   image: './assets/mitra/pesonaedu.png',
    //   width: '120px',
    //   height: '60px',
    //   name: 'PT Pesona Edukasi',
    //   link: 'https://siplah.pesonaedu.id/',
    //   phone: '0812 - 11511121',
    //   link_panduan: 'https://siplah.pesonaedu.id/guide',
    //   link_daftar: 'https://siplah.pesonaedu.id/register',
    // },
    // {
    //   image: './assets/mitra/tisera.png',
    //   width: '120px',
    //   height: '60px',
    //   name: 'PT Tiga Serangkai Pustaka Mandiri',
    //   link: 'https://siplah.tisera.id/',
    //   phone: '0271 - 714344',
    //   link_panduan: 'https://siplah.tisera.id/panduan',
    //   link_daftar: 'https://siplah.tisera.id/register/penjual',
    // },
    // {
    //   image: './assets/mitra/datascript.png',
    //   width: '120px',
    //   height: '60px',
    //   name: 'PT Datascrip',
    //   link: 'https://siplah.datascripmall.id/',
    //   phone: '021 - 26648999',
    //   link_panduan:
    //     'https://siplah.datascripmall.id/blog/Video-Panduan-Transaksi',
    //   link_daftar: 'https://siplah.datascripmall.id/register',
    // },
    // {
    //   image: './assets/mitra/air mas.png',
    //   width: '120px',
    //   height: '60px',
    //   name: 'PT Air Mas Perkasa',
    //   link: 'https://siplah.rajastore.id/',
    //   phone: '021 - 6304444',
    //   link_panduan: 'https://siplah.rajastore.id/pages/cara-pembelian',
    //   link_daftar: 'https://siplah.rajastore.id/merchant/register',
    // },
    // {
    //   image: './assets/mitra/omah.png',
    //   width: '120px',
    //   height: '60px',
    //   name: 'PT Omah Teknologi Indonesia',
    //   link: 'https://siplah.belanja24.com/',
    //   phone: '0812 - 852424',
    //   link_panduan: 'https://siplah.belanja24.com/about/cara_pemakaian',
    //   link_daftar: 'https://seller-siplah.belanja24.com/register',
    // },
  ]
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Penyedia | Situs Informasi SIPLah</title>
        <link
          rel="canonical"
          href="siplah.kemendikdasmen.go.id/penyedia-barang-jasa"
        />
        <meta http-equiv="Cache-control" content="max-age=31536000"></meta>
        <meta name="title" content="Penyedia | Situs Informasi SIPLah"></meta>
        <meta
          name="description"
          content="Cari tahu keuntungan dan cara berjualan di SIPLah."
        ></meta>
      </Helmet>
      <div className="h-100">
        <section className="bg-dark-blue text-white overflow-x-hidden">
          <Container className="container-satdik">
            <Row gutter={[16, 16]}>
              <Col
                lg={13}
                md={24}
                sm={24}
                xs={24}
                className="gap-wrapper-offside"
              >
                <div className="text-caption-header text-white-smoke m-b-24 gap-header-satdik-100">
                  <b>Penyedia Barang dan Jasa</b>
                </div>
                <h1 className="font-switzer-bold text-white text-header-satdik text-head-satdik">
                  <b className="font-light-bold">
                    Perluas jangkauan usaha Anda ke ratusan ribu sekolah di
                    Indonesia.
                  </b>
                </h1>
              </Col>
              <Col lg={11} md={24} sm={24} xs={24} className="text-right">
                <img
                  src="./assets/homepage/img-penyedia-desktop.svg"
                  className="img-block d-none d-xl-block float-right"
                  alt="penyedia-desktop"
                />
                <img
                  src="./assets/homepage/img-penyedia-desktop.svg"
                  className="img-block d-none d-lg-block d-xl-none float-right"
                  alt="penyedia-desktop"
                />
                <img
                  src="./assets/homepage/img-penyedia-tablet.svg"
                  className="img-block d-none d-md-block d-lg-none"
                  alt="penyedia-tablet"
                />
                <img
                  src="./assets/homepage/img-penyedia-mobile.svg"
                  className="img-block d-none d-sm-block d-md-none"
                  alt="penyedia-mobile"
                />
                <img
                  src="./assets/homepage/img-penyedia-mobile.svg"
                  className="img-block d-block d-sm-none"
                  alt="penyedia-mobile"
                />
              </Col>
            </Row>
          </Container>
        </section>
        <section className="bg-white-smoke section-penyedia">
          <Container>
            <div className="font-size-28-27 m-b-16">
              <b>Siapa yang dimaksud Penyedia?</b>
            </div>
            <div className="font-size-20-16">
              Penyedia adalah penjual barang dan jasa kebutuhan sekolah yang
              tergabung di Mitra pengelola pasar daring SIPLah. Untuk bisa
              bergabung, Penyedia perlu mendaftarkan usahanya dan mempelajari
              kriteria yang berlaku.
            </div>
          </Container>
        </section>
        <section className="section-body-3">
          <Container>
            <div>
              <h2 className="font-switzer-semibold gap-text-header-64">
                <b>Keuntungan utama berjualan di SIPLah</b>
              </h2>
              <Row gutter={[16, 16]}>
                <Col lg={8} md={12} sm={12} xs={24}>
                  <div className="width-328">
                    <img
                      src="./assets/homepage/memperluas-peluang-baru.svg"
                      alt="satuan_pendidikan"
                      width="60"
                      className="m-t-20 m-b-24"
                    />
                    <div className="font-size-22 m-b-12">
                      <b>Memperluas peluang baru</b>
                    </div>
                    <div className="grey-text font-size-16 m-b-10">
                      Dengan himbauan resmi ke semua sekolah di Indonesia untuk
                      belanja di SIPLah, calon pembeli Anda akan terus
                      bertambah.
                    </div>
                  </div>
                </Col>
                <Col lg={8} md={12} sm={12} xs={24}>
                  <div className="width-328">
                    <img
                      src="./assets/homepage/permintaan-selalu-ada.svg"
                      alt="satuan_pendidikan"
                      width="60"
                      className="m-t-20 m-b-24"
                    />
                    <div className="font-size-22 m-b-12">
                      <b>Permintaan selalu ada</b>
                    </div>
                    <div className="grey-text font-size-16 m-b-10">
                      Karena kebutuhan sekolah akan jenis barang dan jasa
                      cenderung sama dan rutin, produk Anda akan selalu dicari.
                    </div>
                  </div>
                </Col>
                <Col lg={8} md={12} sm={12} xs={24}>
                  <div className="width-328">
                    <img
                      src="./assets/homepage/minim-resiko-penipuan.svg"
                      alt="satuan_pendidikan"
                      width="60"
                      className="m-t-20 m-b-24"
                    />
                    <div className="font-size-22 m-b-12">
                      <b>Minim risiko penipuan</b>
                    </div>
                    <div className="grey-text font-size-16 m-b-10">
                      Lewat dukungan pemerintah dan instansi resmi sebagai
                      pelanggan Anda, semakin kecil kemungkinan Anda mengalami
                      rugi.
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
        <hr />
        <section className="section-body-2">
          <Container>
            <h2 className="font-switzer-semibold m-b-24">
              <b>Kata mereka yang sudah menjadi Penyedia</b>
            </h2>
            <div className="font-size-20 satdik-text-container">
              Lebih dari <b>100.000 penjual barang dan jasa</b> telah meraih
              keuntungan tambahan dengan bergabung di SIPLah. Berikut beberapa
              pengalaman mereka.
            </div>
          </Container>
        </section>
        <section className="bg-dark-blue p-b-44 height-step-satdik">
          <Container className="align-items-center text-center">
            <div className="position-relative satdik-video-container">
              <div className="position-relative">
                <a onClick={() => handleClickVideo()}>
                  <span className="material-icons text-blue button-play-video-big">
                    play_circle_filled
                  </span>
                </a>
              </div>
              <div className="m-t-10 m-b-40">
                <img
                  src="./assets/homepage/penyedia-video.png"
                  alt="play-video"
                  className="img-block img-darken"
                />
              </div>
              <div className="text-center text-satdik-video">
                <b className="font-size-27 text-white">Testimonial Penyedia</b>
                <div className="text-white">
                  Ketahui manfaat SIPLah langsung dari pengguna
                </div>
              </div>
            </div>
          </Container>
          <Container className="position-relative container-slider">
            <div className="position-relative satdik-slider-container slider-homepage">
              <Slider {...settings}>
                <div className="why-use-siplah m-t-10 m-b-10 why-height">
                  <div className="inside-quote">
                    <div>
                      <img
                        src="./assets/quotes/quotes-1.png"
                        alt="quotes"
                        width="27"
                        className="m-b-20"
                      />
                      <div className="font-size-22 m-b-30">
                        Dari awal proses bergabung, informasi cara bertransaksi
                        antara penjual dan pembeli sudah{' '}
                        <span className="bg-light-orange">
                          sangat jelas lewat video tutorial yang diberikan
                        </span>
                        . Sehingga sampai saat ini transaksi yang pernah saya
                        lakukan berjalan dengan lancar.
                      </div>
                    </div>
                    <Row gutter={[16, 16]} className="align-items-center">
                      <Col
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        className="p-r-0 text-right"
                      >
                        <img
                          src="./assets/quotes/ava-penyedia-1.png"
                          alt="quotes"
                          className="img-quotes"
                        />
                      </Col>
                      <Col
                        lg={20}
                        md={18}
                        sm={18}
                        xs={18}
                        className="p-l-0 text-left"
                      >
                        <b>Ivony</b>
                        <div className="grey-text">
                          <b>
                            PT Dinamika Wisesa Persada &#183; DKI Jakarta &#183;
                            Penyedia
                          </b>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="why-use-siplah m-t-10 m-b-10 why-height">
                  <div className="inside-quote">
                    <div>
                      <img
                        src="./assets/quotes/quotes-2.png"
                        alt="quotes"
                        width="27"
                        className="m-b-20"
                      />
                      <div className="font-size-22 m-b-30">
                        Menurut saya, SIPLah inilah yang paling bisa menyentuh
                        UMKM{' '}
                        <span className="bg-light-orange">
                          sampai ke pelosok pedesaan
                        </span>
                        . Biarpun kami UMKM kecil di Jambi, kami tetap mendapat
                        bimbingan tentang pengetahuan berbisnis.
                      </div>
                    </div>
                    <Row gutter={[16, 16]} className="align-items-center">
                      <Col
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        className="p-r-0 text-right"
                      >
                        <img
                          src="./assets/quotes/ava-penyedia-2.png"
                          alt="quotes"
                          className="img-quotes"
                        />
                      </Col>
                      <Col
                        lg={20}
                        md={18}
                        sm={18}
                        xs={18}
                        className="p-l-0 text-left"
                      >
                        <b>Aditya Puspa</b>
                        <div className="grey-text">
                          <b>Ampere Meubel &#183; Jambi &#183; Penyedia</b>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="why-use-siplah m-t-10 m-b-10 why-height">
                  <div className="inside-quote">
                    <div>
                      <img
                        src="./assets/quotes/quotes-1.png"
                        alt="quotes"
                        width="27"
                        className="m-b-20"
                      />
                      <div className="font-size-22 m-b-30">
                        Di awal pakai SIPLah memang agak kesulitan terutama saat
                        upload barang dan input PPN. Tapi setelah kita{' '}
                        <span className="bg-light-orange">
                          dipandu dari team pelaksana SIPLah yang cepat respon
                        </span>
                        , alhamdullilah sekarang sudah lebih mudah untuk
                        bertransaksi.
                      </div>
                    </div>
                    <Row gutter={[16, 16]} className="align-items-center">
                      <Col
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        className="p-r-0 text-right"
                      >
                        <img
                          src="./assets/quotes/ava-penyedia-3.png"
                          alt="quotes"
                          className="img-quotes"
                        />
                      </Col>
                      <Col
                        lg={20}
                        md={18}
                        sm={18}
                        xs={18}
                        className="p-l-0 text-left"
                      >
                        <b>Hardo</b>
                        <div className="grey-text">
                          <b>
                            CV Sinar Cerah &#183; Jawa Tengah &#183; Penyedia
                          </b>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Slider>
            </div>
          </Container>
        </section>
        <section className="section-body-4">
          <Container>
            <h2 className="font-switzer-reguler m-b-64-44">
              <b>5 langkah berjualan di SIPLah</b>
            </h2>
            <div className="d-none d-md-block d-lg-block d-xl-block align-items-center">
              <Row
                gutter={[16, 16]}
                className="m-t-50 m-b-30 align-items-start"
              >
                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className="sticky-md-top sticky-siplah"
                >
                  <img
                    src={getImage()}
                    alt="cara-kerja"
                    ref={imageRef}
                    className="img-semiblock"
                  />
                </Col>
                <Col lg={12} md={12} sm={24} xs={24}>
                  <div
                    className="width-step display-flex flex-column justify-content-center"
                    ref={firstContainer}
                  >
                    <div className="text-primary m-b-16 font-size-14">
                      <b>LANGKAH 1</b>
                    </div>
                    <h3 className="m-b-16">
                      <b>
                        Penyedia mendaftarkan diri ke Mitra pengelola pasar
                        daring
                      </b>
                    </h3>
                    <div className="grey-text font-size-16 text-left">
                      Penyedia mengisi formulir pendaftaran di situs Mitra
                      pengelola pasar daring dan melengkapi beberapa dokumen
                      persyaratan. Setelah berkas terverifikasi, Penyedia akan
                      mendapatkan akses untuk masuk ke <i>Dasbor</i> Mitra.
                    </div>
                  </div>
                  <div
                    className="width-step display-flex flex-column justify-content-center"
                    ref={secondContainer}
                  >
                    <div className="text-primary m-b-16 font-size-14">
                      <b>LANGKAH 2</b>
                    </div>
                    <h3 className="m-b-16">
                      <b>Penyedia input produk yang dijual</b>
                    </h3>
                    <div className="grey-text font-size-16 text-left">
                      Penyedia dapat menginput produk satu per satu atau dalam
                      jumlah banyak melalui format yang tersedia. Semua produk
                      yang diinput akan di-<i>review</i> oleh Mitra pengelola
                      pasar daring untuk menjamin kualitasnya.
                    </div>
                  </div>
                  <div
                    className="width-step display-flex flex-column justify-content-center"
                    ref={thirdContainer}
                  >
                    <div className="text-primary m-b-16 font-size-14">
                      <b>LANGKAH 3</b>
                    </div>
                    <h3 className="m-b-16">
                      <b>Penyedia menerima pesanan</b>
                    </h3>
                    <div className="grey-text font-size-16 text-left">
                      Penyedia boleh melakukan negosiasi terkait harga, waktu
                      dan biaya pengiriman, serta termin pembayaran. Setelah
                      tercapai kesepakatan, Mitra pengelola pasar daring akan
                      membuatkan surat pemesanan sebagai pegangan Penyedia untuk
                      memproses dan mengirimkan pesanan.
                    </div>
                  </div>
                  <div
                    className="width-step display-flex flex-column justify-content-center"
                    ref={fourthContainer}
                  >
                    <div className="text-primary m-b-16 font-size-14">
                      <b>LANGKAH 4</b>
                    </div>
                    <h3 className="m-b-16">
                      <b>Penyedia mengirimkan pesanan</b>
                    </h3>
                    <div className="grey-text font-size-16 text-left">
                      Setelah produk diterima, Satdik akan memeriksa kesesuaian
                      pesanan. Jika tidak ada komplain, Satdik akan mencetak
                      Berita Acara Serah Terima (BAST) dan melakukan pembayaran
                      melalui <i>virtual account</i> atau transfer bank ke Mitra
                      pengelola pasar daring.
                    </div>
                  </div>
                  <div
                    className="width-step display-flex flex-column justify-content-center"
                    ref={fifthContainer}
                  >
                    <div className="text-primary m-b-16 font-size-14">
                      <b>LANGKAH 5</b>
                    </div>
                    <h3 className="m-b-16">
                      <b>Penyedia menerima pembayaran</b>
                    </h3>
                    <div className="grey-text font-size-16 text-left">
                      Mitra pengelola pasar daring akan melakukan verifikasi
                      atas pesanan yang telah dikirimkan Penyedia. Jika semua
                      dokumen konfirmasi telah lengkap, pembayaran akan langsung
                      disalurkan ke rekening Penyedia.
                    </div>
                  </div>
                  <br />
                </Col>
              </Row>
            </div>
            <div className="d-block d-sm-block d-md-none">
              <Row gutter={[16, 16]} className="m-t-30">
                <Col sm={24}>
                  <img
                    src="./assets/cara-kerja/img-penyedia-daftar.png"
                    alt="cara-kerja"
                    className="img-block "
                  />
                </Col>
                <Col sm={24}>
                  <div className="text-primary m-t-24 m-b-16 font-size-14">
                    <b>LANGKAH 1</b>
                  </div>
                  <h3 className="m-b-16">
                    <b>
                      Penyedia mendaftarkan diri ke Mitra pengelola pasar daring
                    </b>
                  </h3>
                  <div className="grey-text font-size-16 text-left">
                    Penyedia mengisi formulir pendaftaran di situs Mitra
                    pengelola pasar daring dan melengkapi beberapa dokumen
                    persyaratan. Setelah berkas terverifikasi, Penyedia akan
                    mendapatkan akses untuk masuk ke <i>Dasbor</i> Mitra.
                  </div>
                </Col>
              </Row>
              <br />
              <Row gutter={[16, 16]} className="m-t-30">
                <Col sm={24}>
                  <img
                    src="./assets/cara-kerja/img-penyedia-input-produk.png"
                    alt="cara-kerja"
                    className="img-block "
                  />
                </Col>
                <Col sm={24}>
                  <div className="text-primary m-t-24 m-b-16 font-size-14">
                    <b>LANGKAH 2</b>
                  </div>
                  <h3 className="m-b-16">
                    <b>Penyedia input produk yang dijual</b>
                  </h3>
                  <div className="grey-text font-size-16 text-left">
                    Penyedia dapat menginput produk satu per satu atau dalam
                    jumlah banyak melalui format yang tersedia. Semua produk
                    yang diinput akan di-<i>review</i> oleh Mitra pengelola
                    pasar daring untuk menjamin kualitasnya.
                  </div>
                </Col>
              </Row>
              <br />
              <Row gutter={[16, 16]} className="m-t-30">
                <Col sm={24}>
                  <img
                    src="./assets/cara-kerja/img-penyedia-menerima-pesanan.png"
                    alt="cara-kerja"
                    className="img-block "
                  />
                </Col>
                <Col sm={24}>
                  <div className="text-primary m-b-16 m-t-24 font-size-14">
                    <b>LANGKAH 3</b>
                  </div>
                  <h3 className="m-b-16">
                    <b>Penyedia menerima pesanan</b>
                  </h3>
                  <div className="grey-text font-size-16 text-left">
                    Penyedia boleh melakukan negosiasi terkait harga, waktu dan
                    biaya pengiriman, serta termin pembayaran. Setelah tercapai
                    kesepakatan, Mitra pengelola pasar daring akan membuatkan
                    surat pemesanan sebagai pegangan Penyedia untuk memproses
                    dan mengirimkan pesanan.
                  </div>
                </Col>
              </Row>
              <br />
              <Row gutter={[16, 16]} className="m-t-30">
                <Col sm={24}>
                  <img
                    src="./assets/cara-kerja/img-penyedia-mengirimkan.png"
                    alt="cara-kerja"
                    className="img-block "
                  />
                </Col>
                <Col sm={24}>
                  <div className="text-primary m-b-16 m-t-24 font-size-14">
                    <b>LANGKAH 4</b>
                  </div>
                  <h3 className="m-b-16">
                    <b>Penyedia mengirimkan pesanan</b>
                  </h3>
                  <div className="grey-text font-size-16 text-left">
                    Setelah produk diterima, Satdik akan memeriksa kesesuaian
                    pesanan. Jika tidak ada komplain, Satdik akan mencetak
                    Berita Acara Serah Terima (BAST) dan melakukan pembayaran
                    melalui <i>virtual account</i> atau transfer bank ke Mitra
                    pengelola pasar daring.
                  </div>
                </Col>
              </Row>
              <br />
              <Row gutter={[16, 16]} className="m-t-30">
                <Col sm={24}>
                  <img
                    src="./assets/cara-kerja/img-penyedia-menerima-pembayaran.png"
                    alt="cara-kerja"
                    className="img-block "
                  />
                </Col>
                <Col sm={24}>
                  <div className="text-primary m-b-16 m-t-24 font-size-14">
                    <b>LANGKAH 5</b>
                  </div>
                  <h3 className="m-b-16">
                    <b>Penyedia menerima pembayaran</b>
                  </h3>
                  <div className="grey-text font-size-16 text-left">
                    Mitra pengelola pasar daring akan melakukan verifikasi atas
                    pesanan yang telah dikirimkan Penyedia. Jika semua dokumen
                    konfirmasi telah lengkap, pembayaran akan langsung
                    disalurkan ke rekening Penyedia.
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
        <section className="section-pertanyaan-umum bg-dark-blue overflow-x-hidden">
          <Container className="container-satdik gap-text-header-44-24">
            <Row gutter={[16, 16]}>
              <Col
                lg={14}
                md={24}
                sm={24}
                xs={24}
                className="d-flex flex-column justify-content-between gap-wrapper-offside"
              >
                <div>
                  <h1 className="font-switzer-bold text-white text-header-satdik text-head-satdik m-b-24">
                    <b className="font-light-bold">
                      Yuk, mulai daftar jadi Penyedia di Mitra SIPLah!
                    </b>
                  </h1>
                  <div className="font-size-20 text-white">
                    <div className="d-none d-xl-block">
                      Jangan lewatkan kesempatan Anda untuk menawarkan
                      <br />
                      barang dan jasa ke ratusan ribu sekolah di seluruh
                      Indonesia.
                    </div>
                    <div className="d-none d-lg-block d-xl-none">
                      Jangan lewatkan kesempatan Anda untuk menawarkan
                      <br />
                      barang dan jasa ke ratusan ribu sekolah di seluruh
                      Indonesia.
                    </div>
                    <div className="d-none d-md-block d-lg-none">
                      Jangan lewatkan kesempatan Anda untuk menawarkan barang
                      dan jasa ke ratusan ribu sekolah di seluruh Indonesia.
                    </div>
                    <div className="d-none d-sm-block d-md-none">
                      Jangan lewatkan kesempatan Anda untuk menawarkan barang
                      dan jasa ke ratusan ribu sekolah di seluruh Indonesia.
                    </div>
                    <div className="d-block d-sm-none">
                      Jangan lewatkan kesempatan Anda untuk menawarkan barang
                      dan jasa ke ratusan ribu sekolah di seluruh Indonesia.
                    </div>
                  </div>
                </div>
                <div className="font-size-22-19 text-white gap-pilihan-mitra">
                  <b>Pilihan Mitra pengelola pasar daring</b>
                </div>
              </Col>
              <Col lg={10} md={24} sm={24} xs={24} className="text-right">
                <img
                  src="./assets/homepage/img-choose-mitra.svg"
                  className="img-block d-none d-xl-block float-right"
                  alt="mitra-desktop"
                />
                <img
                  src="./assets/homepage/img-choose-mitra.svg"
                  className="img-block d-none d-lg-block d-xl-none float-right"
                  alt="mitra-desktop"
                />
              </Col>
            </Row>
          </Container>
          <Container>
            <Row gutter={[16, 16]}>
              {listMitra.map((data, i) => (
                <Col
                  lg={8}
                  md={12}
                  sm={24}
                  xs={24}
                  key={i}
                  className="m-b-24 p-l-0 p-r-0"
                >
                  <div className="mitra-box text-center m-l-12 m-r-12">
                    <div className="img-mitra m-b-24">
                      <img src={data.image} alt="mitra" />
                    </div>
                    <div>
                      <b className="font-size-17">{data.name}</b>
                    </div>
                    <a
                      className="mitra-link font-size-14"
                      href={data.link}
                      target="_blank"
                      onClick={() => handleClickPartner(data.name, 'PARTNER_HOMEPAGE')}
                    >
                      {data.link}
                    </a>
                    <div className="d-flex align-items-center justify-content-between m-b-16 m-t-16">
                      <span className="material-symbols-outlined color-black-icon font-bold font-size-20">
                        phone_in_talk
                      </span>
                      <span className="font-size-14 color-black-text">
                        {data.phone}
                      </span>
                      <span className="m-l-8 m-r-8">&#183;</span>
                      <a
                        className="color-black-text-link font-size-14"
                        href={data.link_panduan}
                        target="_blank"
                        onClick={() => handleClickPartner(data.name, 'PARTNER_GUIDE')}
                      >
                        Panduan
                      </a>
                    </div>
                    <a
                      className="btn btn-block btn-dark"
                      href={data.link_daftar}
                      target="_blank"
                      onClick={() => handleClickPartner(data.name, 'PARTNER_REGISTRATION')}
                    >
                      Daftar Jadi Penyedia
                    </a>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <br />
        <section className="section-pertanyaan-umum bg-white-smoke">
          <Container>
            <h2 className="font-switzer-reguler gap-text-header-64">
              <b>Pertanyaan umum seputar jadi Penyedia</b>
            </h2>
            {collapse.map((data, i) => (
              <Collapsible
                defaultOpen={data.open}
                key={i}
                onClick={() => changeCollapse(data.id)}
              >
                <CollapsibleTrigger
                  className={`bg-white text-left p-b-12 collapse-siplah ${
                    data.id == 1
                      ? 'collapse-first'
                      : data.id == 5
                      ? 'collapse-last'
                      : ''
                  }`}
                >
                  <span className="font-size-19 text-left">{data.title}</span>{' '}
                  <CollapsibleIcon />
                </CollapsibleTrigger>
                <CollapsibleContent>
                  <div
                    className={`break-word grey-text p-l-20 p-r-30 p-b-20 font-size-16 bg-white ${
                      data.id == 5 ? 'collapse-last' : ''
                    }`}
                    dangerouslySetInnerHTML={{ __html: data.content }}
                  />
                </CollapsibleContent>
              </Collapsible>
            ))}
            <div className="m-t-44">
              Punya pertanyaan lain? Kunjungi halaman{' '}
              <a
                href="https://pusatinformasi.rumahpendidikan.kemendikdasmen.go.id/hc/id/categories/52400503427609-SIPLah"
                className="primary-blue text-underline"
                target="_blank"
                onClick={() => handleClickHelpCenter()}
              >
                Pusat Bantuan SIPLah
              </a>
            </div>
          </Container>
        </section>
        <div className="display-flex overflow-x-hidden">
          <span className="line-upper-footer bg-blue" />
          <span className="line-upper-footer bg-orange" />
          <span className="line-upper-footer bg-green" />
          <span className="line-upper-footer bg-pink" />
        </div>
      </div>
      <Modal
        show={isVideoOpen}
        onHide={() => setIsVideoOpen(false)}
        className="modal-video"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="align-right">
          <a onClick={() => setIsVideoOpen(false)}>
            <span className="material-symbols-outlined text-white font-size-20">
              close
            </span>
          </a>
        </Modal.Header>
        <div className="video-container">
          <iframe
            src="https://www.youtube.com/embed/id7XInpDLsI?autoplay=1"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            width="800"
            height="400"
            title="video"
          />
        </div>
      </Modal>
    </>
  )
}
export default Penyedia
